var breakpoints = require("./utilities/breakpoints");
const carouselPrimaryUnit = require("./utilities/carouselPrimaryUnit");
import { prevArrow, nextArrow } from "./utilities/carouselSlickConfig";
import { syncHeightCarouselTiles } from "./utilities/globalUtilities";
import { loadLazyImages } from "./utilities/globalUtilities";

window.addEventListener("load", () => {
    setTimeout(() => {
        initializeCarousel(".experience-commerce_assets-productTiles");
    }, 0);
});

function initializeCarousel(carouselClass, $container) {
    var $bannerCarousel = $container ? $container.closest(".js-productcarousel") : $(".js-productcarousel");
    var $allCarouselFromPage = $bannerCarousel.find(carouselClass);
    if ($allCarouselFromPage.hasClass("slick-initialized")) return;
    var dataSlidesPhone = parseInt($bannerCarousel.attr("data-slides-phone"), 10);
    var dataSlidesTablet = parseInt($bannerCarousel.attr("data-slides-tablet"), 10);
    var dataSlidesDesktop = parseInt($bannerCarousel.attr("data-slides-desktop"), 10);
    var dataSlidesLargeDesktop = parseInt($bannerCarousel.attr("data-slides-large-desktop"), 10);
    var dataIndicatorsPhone = $bannerCarousel.attr("data-indicators-phone") === "true" ? true : false;
    var dataIndicatorsTablet = $bannerCarousel.attr("data-indicators-tablet") === "true" ? true : false;
    var dataIndicatorsDesktop = $bannerCarousel.attr("data-indicators-desktop") === "true" ? true : false;
    var dataIndicatorsLargeDesktop = $bannerCarousel.attr("data-indicators-large-desktop") === "true" ? true : false;
    var dataControlsPhone = $bannerCarousel.attr("data-controls-phone") === "true" ? true : false;
    var dataControlsTablet = $bannerCarousel.attr("data-controls-tablet") === "true" ? true : false;
    var dataControlsDesktop = $bannerCarousel.attr("data-controls-desktop") === "true" ? true : false;
    var dataControlsLargeDesktop = $bannerCarousel.attr("data-controls-large-desktop") === "true" ? true : false;
    var dataAutoplay = $bannerCarousel.attr("data-autoplay") === "true" ? true : false;
    var dataAutoplaySpeed = parseInt($bannerCarousel.attr("data-autoplay-speed"), 10);
    var dataArrowsColor = $bannerCarousel.attr("data-arrows-color");
    var brandID = $bannerCarousel.attr("data-brandid");

    carouselPrimaryUnit.initCarouselProductPrimaryUnit($allCarouselFromPage);
    $bannerCarousel.removeClass("d-none");
    $bannerCarousel.parent().parent().find(".js-productcarousel-skeleton").addClass("d-none");
    $bannerCarousel.parent().find(".js-productcarousel-skeleton").addClass("d-none");
    $bannerCarousel.find(".js-productcarousel-skeleton").addClass("d-none");

    $allCarouselFromPage.each(function () {
        syncHeightCarouselTiles($(this));
    });

    $allCarouselFromPage.slick({
        slidesToShow: dataSlidesLargeDesktop,
        slidesToScroll: dataSlidesLargeDesktop,
        dots: dataIndicatorsLargeDesktop,
        arrows: dataControlsLargeDesktop,
        autoplay: dataAutoplay,
        autoplaySpeed: dataAutoplaySpeed,
        prevArrow: !dataArrowsColor ? prevArrow : `<span class="${brandID}-svgbg-icon-arrow-prev"><svg class="svg-inline icon-arrow-left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 26" width="15" height="26"><path fill="${dataArrowsColor}" fill-rule="evenodd" d="M12.382.308a1.051 1.051 0 0 1 1.487 1.487L2.555 12.99l11.314 11.214c.379.38.408.976.087 1.388l-.087.1a1.048 1.048 0 0 1-1.487 0L.411 13.826l-.1-.087a1.046 1.046 0 0 1-.29-.557l-.005-.017a1.05 1.05 0 0 1 .42-1.037z"/></svg></span>`,
        nextArrow: !dataArrowsColor ? nextArrow : `<span class="${brandID}-svgbg-icon-arrow-next"><svg class="svg-inline icon-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 26" width="15" height="26"><path fill="${dataArrowsColor}" fill-rule="evenodd" d="M1.795.308A1.051 1.051 0 0 0 .308 1.795L11.622 12.99.308 24.205a1.052 1.052 0 0 0-.088 1.388l.088.1a1.048 1.048 0 0 0 1.487 0l11.97-11.866.1-.087c.158-.158.255-.353.291-.557l.004-.017a1.05 1.05 0 0 0-.419-1.037z" /></svg></span>`,
        responsive: [
            {
                breakpoint: breakpoints.values.desktopExtraLarge,
                settings: {
                    slidesToShow: dataSlidesLargeDesktop,
                    slidesToScroll: dataSlidesLargeDesktop,
                    arrows: dataControlsLargeDesktop,
                    dots: dataIndicatorsLargeDesktop
                }
            },
            {
                breakpoint: breakpoints.values.desktopLarge,
                settings: {
                    slidesToShow: dataSlidesDesktop,
                    slidesToScroll: dataSlidesDesktop,
                    arrows: dataControlsDesktop,
                    dots: dataIndicatorsDesktop
                }
            },
            {
                breakpoint: breakpoints.values.desktop,
                settings: {
                    slidesToShow: dataSlidesTablet,
                    slidesToScroll: dataSlidesTablet,
                    arrows: dataControlsTablet,
                    dots: dataIndicatorsTablet
                }
            },
            {
                breakpoint: breakpoints.values.tablet,
                settings: {
                    slidesToShow: dataSlidesPhone,
                    slidesToScroll: dataSlidesPhone,
                    arrows: dataControlsPhone,
                    dots: dataIndicatorsPhone
                }
            }
        ]
    });

    loadLazyImages(".js-productcarousel");
}

export { initializeCarousel };
